/* ==========================================================================
   Navigation — one source of truth for the header, the mobile drawer,
   the footer, and the sitemap.
   ========================================================================== */

export const primaryNav = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about-us' },
  {
    label: 'Capabilities',
    to: '/capabilities',
    /* Five services, matching the client's confirmed structure. The four
       AI/quantum areas are sections inside the first item, not siblings —
       that is how they are organised in Website-Updates.docx. */
    children: [
      { label: 'AI Governance & Quantum-Ready Cybersecurity', to: '/capabilities/ai-governance-quantum-ready-cybersecurity' },
      { label: 'Cybersecurity Solutions',                     to: '/capabilities/cybersecurity-solutions' },
      { label: 'Change Management and IT Service Management',  to: '/capabilities/change-and-it-service-management' },
      { label: 'Enterprise Services',                          to: '/capabilities/enterprise-services' },
      { label: 'LscNexus Transportation & Mobility Solutions',  to: '/lscnexus' },
    ],
  },
  { label: 'Industries', to: '/industries' },
  { label: 'Past Performance', to: '/past-performance' },
  { label: 'Contact', to: '/contact-us' },
];

/* Legacy URLs from the previous site, preserved so inbound links and any
   indexed pages do not 404. Each redirects to its new home. */
export const legacyRedirects = [
  { from: '/services', to: '/capabilities' },
  { from: '/services/cybersecurity-solutions', to: '/capabilities/cybersecurity-solutions' },

  { from: '/services/change-and-IT-management', to: '/capabilities/change-and-it-service-management' },
  { from: '/services/enterprise-services', to: '/capabilities/enterprise-services' },
  { from: '/clients', to: '/past-performance' },
];

export const footerNav = [
  {
    heading: 'Capabilities',
    links: primaryNav.find((i) => i.label === 'Capabilities').children,
  },
  {
    heading: 'Company',
    links: [
      { label: 'About Us', to: '/about-us' },
      { label: 'LscNexus — Transportation', to: '/lscnexus' },
      { label: 'Industries Served', to: '/industries' },
      { label: 'Past Performance', to: '/past-performance' },
      { label: 'Capability Statement', to: '/capability-statement' },
      { label: 'Contact', to: '/contact-us' },
    ],
  },
];
